import account from "../../../pages/account";
import { GetPatientEmailDetails } from "./actions";
import {
    SET_USER_DETAILS,
    SET_USER_BILLING_DETAILS,
    SET_USER_CARD_DETAILS,
    SET_USER_WORKOUT_HISTORY,
    SET_USER_SURVEY,
    SET_FAVORITES_IDS,
    SET_FINISHED_WORKOUTS_IDS,
    SET_LATEST_SURVEY_SCORES,
    SET_USER_CHILD_DETAILS,
    SET_SELECTED_PROGRAM,
    SET_USER_ALL_WORKOUT_HISTORY,
    SET_USER_ALL_WORKOUT_HISTORY_WITH_ARCHIVED,
    SET_SURVEY_QUESTIONS,
    SET_SELECTED_PROGRAMS,
    SET_USER_NOTIFICATIONS,
    SET_ACCOUNT_DETAILS,
    SET_INVITATION_DETAILS,
    SET_PATIENT_EMAIL_DETAILS,
    SET_SURVEY_GOALS,
} from "./types";

const initialState = {
    account: {},

    user: {},
    billing: {},

    card: {},

    survey: {
        answers: [],
        goals: [],
    },

    latestSurveyScores: null,

    workoutHistory: null,

    favorites: null,

    allFinished: null,

    allWorkoutHistory: [],
    allWorkoutHistoryWithArchived: [],

    surveyQuestions: [],
    surveyGoals: [],
    selectedPrograms: [],

    notifications: null,

    invitationDetails: {
        eventID: null,
        emailID: null,
        signupType: null,
    },
    patientEmailDetails: null,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case SET_SURVEY_GOALS:
            return {
                ...state,
                surveyGoals: action.list,
            }

        case SET_PATIENT_EMAIL_DETAILS:
            return {
                ...state,
                patientEmailDetails: action.details,
            };

        case SET_INVITATION_DETAILS:
            return {
                ...state,
                invitationDetails: action.details,
            };


        case SET_ACCOUNT_DETAILS:
            return {
                ...state,
                account: action?.details ? { ...action?.details } : { ...state.account },
                user: action?.details?.user ? {
                    ...action?.details?.user,
                } : { ...state.user },
            };

        case SET_USER_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.list,
            };

        case SET_SELECTED_PROGRAMS:
            return {
                ...state,
                selectedPrograms: action.list,
            };

        case SET_SURVEY_QUESTIONS:
            return {
                ...state,
                surveyQuestions: action.list,
            };

        case SET_USER_ALL_WORKOUT_HISTORY_WITH_ARCHIVED:
            return {
                ...state,
                allWorkoutHistoryWithArchived: action.list,
            };

        case SET_USER_ALL_WORKOUT_HISTORY:
            return {
                ...state,
                allWorkoutHistory: action.list,
            };

        case SET_SELECTED_PROGRAM:
            return {
                ...state,
                user: {
                    ...state.user,
                    selected_program: action.data,
                },
            };

        case SET_USER_DETAILS:
            return {
                ...state,
                user: action.details,
            };

        case SET_USER_CHILD_DETAILS:
            return {
                ...state,
                user: {
                    ...state.user,
                    child_user_info: action.details,
                },
            };

        case SET_USER_BILLING_DETAILS:
            return {
                ...state,
                billing: action.details,
            };

        case SET_USER_CARD_DETAILS:
            return {
                ...state,
                card: action.details,
            };

        case SET_USER_WORKOUT_HISTORY:
            return {
                ...state,
                workoutHistory: action.list,
            };

        case SET_USER_SURVEY:
            return {
                ...state,
                survey: action.details,
            };

        case SET_FAVORITES_IDS:
            return {
                ...state,
                favorites: action.data,
            };

        case SET_FINISHED_WORKOUTS_IDS:
            return {
                ...state,
                allFinished: action.data,
            };

        case SET_LATEST_SURVEY_SCORES:
            return {
                ...state,
                latestSurveyScores: action.data,
            };

        default:
            return state;
    }
}
